export const checkOverflow = (id: string): boolean => {
  const element = document.getElementById(id);
  return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
};
